import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@landtrustinc/design-system';
import { Accordion } from '..';

import css from './SectionFAQ.module.css';

const SectionFAQ = props => {
  const { faqs } = props;

  return (
    <div className={css.sectionContainer}>
      <Heading size="2xs" color="var(--text-primary)" fontWeight="bold">
        <FormattedMessage id="SectionFAQ.SectionFAQHeading" />
      </Heading>
      <div className={css.accordionContainer}>
        <Accordion items={faqs} />
      </div>
    </div>
  );
};

SectionFAQ.defaultProps = {};

SectionFAQ.propTypes = {};

export default SectionFAQ;
